import React, { useCallback } from 'react';
import { Grid, makeStyles, Modal, Paper, Typography } from '@material-ui/core';
import CustomButton from '../../control/button/Button';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    modalLabel: {
        fontSize: '20px',
        fontWeight: '700',
    },
    modalValue: {
        fontWeight: '400',
    },
    label: {
        fontSize: '30px',
        fontWeight: '400',
        paddingBottom: '4px',
    },
    baseBtn: {
        width: '100%',
        height: '48px',
    },
    btnCancel: {
        backgroundColor: '#808080 !important',
        width: '100%',
    },
    btnConfirm: {
        backgroundColor: '#F78427 !imporant',
        width: '100%',
    },
    btnRegister: {
        width: '140px',
    },
    paper: {
        overflowY: 'auto',
        overflowX: 'hidden',
        backgroundColor: theme.palette.background.paper,
        padding: '24px',
        width: '400px',
        [theme.breakpoints.down('xs')]: {
            width: '90%',
            padding: '12px',
        },
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainBody: {
        '& .MuiGrid-item': {
            padding: 0,
        },
    },
    footer: {
        paddingTop: '32px',
    },
    checkIcon: {
        color: '#28A745',
        fontSize: '64px',
    },
    crossIcon: {
        color: '#EA4848',
        fontSize: '64px',
    },
    gridBody: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    successMessage: {
        textAlign: 'center',
        fontSize: '34px',
        fontWeight: '700',
        color: '#28A745',
        paddingTop: '16px',
    },
    errorTitle: {
        textAlign: 'center',
        fontSize: '34px',
        fontWeight: '700',
        color: '#EA4848',
        paddingTop: '16px',
    },
    errorMessage: {
        textAlign: 'center',
        fontSize: '20px',
        color: '#EA4848',
        paddingTop: '8px',
    },
}));

const AlertModal = ({
    errorTitle = 'ลงทะเบียนไม่สำเร็จ',
    errorMessage,
    successMessage,
    handleCloseModalError,
    handleCloseModalSuccess,
}) => {
    const classes = useStyles();
    const handleClose = useCallback(() => {
        if (errorMessage) {
            handleCloseModalError();
        } else if (successMessage) {
            handleCloseModalSuccess();
        }
    }, [
        errorMessage,
        successMessage,
        handleCloseModalError,
        handleCloseModalSuccess,
    ]);
    return (
        <Modal
            open={errorMessage || successMessage}
            onClose={handleClose}
            className={classes.modal}
        >
            <Paper className={classes.paper}>
                <Grid container justify="center">
                    <Grid container className={classes.mainBody} spacing={2}>
                        {successMessage && (
                            <Grid item xs={12} className={classes.gridBody}>
                                <CheckCircleOutlineIcon
                                    className={classes.checkIcon}
                                />
                                <Typography className={classes.successMessage}>
                                    {successMessage}
                                </Typography>
                            </Grid>
                        )}
                        {errorMessage && (
                            <Grid item xs={12} className={classes.gridBody}>
                                <CancelOutlinedIcon
                                    className={classes.crossIcon}
                                />
                                <Typography className={classes.errorTitle}>
                                    {errorTitle}
                                </Typography>
                                <Typography className={classes.errorMessage}>
                                    {errorMessage.split('<br/>').map((item) => (
                                        <>
                                            {item}
                                            <br />
                                        </>
                                    ))}
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                    <Grid
                        container
                        spacing={2}
                        justify="center"
                        className={classes.footer}
                    >
                        <Grid item xs={12}>
                            <CustomButton
                                label={errorMessage ? 'ปิด' : 'ตกลง'}
                                onClick={handleClose}
                                className={clsx(
                                    classes.baseBtn,
                                    errorMessage
                                        ? classes.btnCancel
                                        : classes.btnConfirm
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </Modal>
    );
};

export default AlertModal;
